'use strict';

export default angular
  .module('maestro.services.cache', [])
  .service('CacheService', CacheService)
  .name;

function CacheService($q, webcore) {
  let globalCache = {};
  let index = 0;

  angular.extend(this, {
    drop: drop,
    cachePromiseFunc: cachePromiseFunc
  });

  webcore.services.auth.onLogout.on(() => {
    drop();
  });

  /**
   * Drop cache
   */
  function drop() {
    for (let cacheIndex in globalCache) {
      if (globalCache.hasOwnProperty(cacheIndex)) {
        globalCache[cacheIndex].length = 0;
      }
    }
  }

  /**
   * Caching wrapper for promise-returning functions
   * @param {Function} func
   * @param {number} [cacheExpirationTime] Cache expiration time in ms
   * @return {Function}
   */
  function cachePromiseFunc(func, cacheExpirationTime) {
    const currentCacheIndex = index++;

    /**
     * @type {Array<{time: number, args: Array, result?: Object, error?: Object, resolved?: boolean, rejected?: boolean, promise: Promise<Object>}>}
     */
    let cache = [];
    globalCache[currentCacheIndex] = cache;

    let f = function() {
      let argsArr = Array.from(arguments);
      let cachedItem = cache.find(c => angular.equals(argsArr, c.args));

      if (cachedItem) {
        if (cacheExpirationTime && (new Date().getTime() - cachedItem.time) > cacheExpirationTime) {
          // cache expired
          cache = cache.filter(c => c !== cachedItem);
        } else if (cachedItem.resolved) {
          return $q.resolve(angular.copy(cachedItem.result));
        } else if (cachedItem.rejected) {
          // if rejected - request again
        } else if (cachedItem.promise) {
          return $q.when(cachedItem.promise).then((data) => angular.copy(data));
        }
      }

      argsArr = angular.copy(argsArr); // to avoid post-process arguments editing

      let promise = func.apply(this, arguments);
      let newCacheEntry = {
        time: new Date().getTime(),
        args: argsArr,
        promise: $q.when(promise)
      };
      cache.push(newCacheEntry);

      $q.when(promise)
        .then(result => {
          newCacheEntry.result = angular.copy(result);
          newCacheEntry.resolved = true;
          newCacheEntry.promise = void 0;
        }, error => {
          newCacheEntry.error = error;
          newCacheEntry.rejected = true;
          newCacheEntry.promise = void 0;
        });
      return $q.when(promise);
    };

    /**
     * Clear cache based on list of arguments
     */
    f.clearCache = function() {
      let argsArr = Array.from(arguments);
      cache = cache.filter(c => !angular.equals(argsArr, c.args));
    };

    /**
     * Clear cache based on list of arguments
     */
    f.getLastCacheDate = function() {
      let argsArr = Array.from(arguments);
      const cacheEntries = cache.filter(c => angular.equals(argsArr, c.args));
      cacheEntries.sort((a, b) => b.time - a.time);
      return cacheEntries[0]?.time;
    };

    /**
     * Clear entire cache for this function
     */
    f.clearEntireCache = function() {
      cache = [];
    };

    return f;
  }


}
